export default __webpack_public_path__ + "static/media/travel_stamps.9bfbd0d7.png";